/**
 * Created by TzuHsing on 2020-02-15
 */
import React, { Component } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { Menu, Tabs, Modal, Input, Upload, message } from 'antd'
import { UPLOADED, UNPUBLISHED, UNCHECK, DELETED, OK } from '../constants'
import AdvManageGoods from './AdvManageGoods'
const { TabPane } = Tabs
class AdvManage extends Component {
  state = {
    isShowAddAdv: false,
    confirmLoading: false,
    qiuNiuToken: '',
    previewVisible: false,
    previewImage: '',
    fileList: [],
    typingTitle: '',
    typingPrice: '',
    typingUrl: '',
    isTabPane: UPLOADED,
  }
  handleAddAdv = () => {
    this.setState({ isShowAddAdv: true })
  }
  handleOk = () => {
    const { clubId, getAdvInfo } = this.props
    const { typingTitle, typingPrice, typingUrl, fileList } = this.state
    if (
      fileList.length === 0 ||
      typingTitle === '' ||
      typingPrice === '' ||
      typingUrl === ''
    ) {
      message.error('请确定你新增的广告内容完整！')
      return false
    } else {
      if (typingUrl.indexOf('sport147.cn/') >= 0) {
        this.setState(
          {
            confirmLoading: true,
          },
          () => {
            this.props.addAdv(
              {
                club_id: clubId,
                title: typingTitle,
                url: typingUrl,
                price: typingPrice,
                image_url: fileList[0].response.url,
              },
              (res) => {
                this.setState(
                  {
                    confirmLoading: false,
                    isShowAddAdv: false,
                    fileList: [],
                    typingTitle: '',
                    typingPrice: '',
                    typingUrl: '',
                  },
                  () => {
                    if (res.status === OK) {
                      message.success('操作成功!')
                      getAdvInfo(clubId, 1, () => {
                        this.changeTabPane(UNCHECK)
                      })
                    } else {
                      message.success(res.detail)
                    }
                  }
                )
              }
            )
          }
        )
      } else {
        message.error('只能输入sport147旗下的网址！')
        return false
      }
    }
  }
  handleCancel = () => {
    this.setState({
      isShowAddAdv: false,
      fileList: [],
      typingTitle: '',
      typingPrice: '',
      typingUrl: '',
    })
  }
  handleAddAdvTyping = (e, str) => {
    this.setState({ [str]: e.target.value })
  }

  handlePreview = (file) => {
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true,
    })
  }
  beforeUpload = async (file) => {
    const res = /(image\/png)|(image\/jpeg)/
    if (res.test(file.type)) {
      return await this.props.fetchQiuNiuToken(this)
    } else {
      this.setState({ qiuNiuToken: '' })
      message.error('只能上传 JPG/PNG 格式的图片!')
      return Upload.LIST_IGNORE
    }
  }
  handleChange = ({ fileList }) => {
    this.setState({ fileList })
  }
  handlePreviewCancel = () => {
    this.setState({ previewVisible: false })
  }
  changeTabPane = (key) => {
    this.setState({ isTabPane: key })
  }
  render() {
    const {
      isShowAddAdv,
      confirmLoading,
      previewVisible,
      previewImage,
      fileList,
      typingTitle,
      typingPrice,
      typingUrl,
      isTabPane,
    } = this.state
    const uploadButton = (
      <div>
        <PlusOutlined />
        <div className="ant-upload-text">Upload</div>
      </div>
    )
    const clubName = sessionStorage.getItem('club_name')
    const advManageTitle =
      clubName && clubName.length >= 14
        ? 'advManageSmallTitle'
        : 'advManageTitle'
    return (
      <div className="advManage">
        <div className="advManageHeader">
          <div className={advManageTitle}>{`${
            clubName && clubName
          }广告管理`}</div>
          <a onClick={this.handleAddAdv} className="advManageLink">
            新增广告
          </a>
        </div>
        <Menu />
        <div className="advManageContent">
          <Tabs
            tabBarStyle={{ border: 'none', height: '100%' }}
            activeKey={isTabPane}
            onTabClick={this.changeTabPane}
          >
            <TabPane tab="已发布" key={UPLOADED}>
              <AdvManageGoods
                {...this.props}
                advState={3}
                getUploadFunc={this.getUploadFunc}
              />{' '}
              {/* advState为判断使用哪个list的依据*/}
            </TabPane>
            <TabPane tab="未发布" key={UNPUBLISHED}>
              <AdvManageGoods
                {...this.props}
                advState={2}
                getUploadFunc={this.getUploadFunc}
              />
            </TabPane>
            <TabPane tab="待审核" key={UNCHECK}>
              <AdvManageGoods
                {...this.props}
                advState={1}
                getUploadFunc={this.getUploadFunc}
              />
            </TabPane>
            <TabPane tab="已删除" key={DELETED}>
              <AdvManageGoods
                {...this.props}
                advState={4}
                getUploadFunc={this.getUploadFunc}
              />
            </TabPane>
          </Tabs>
        </div>
        <Modal
          title="请输入完善你需要新增的广告"
          visible={isShowAddAdv}
          confirmLoading={confirmLoading}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          destroyOnClose
        >
          <div className="addAdvModal">
            <label>标题:</label>
            <Input
              size="small"
              placeholder="请输入商品标题"
              value={typingTitle}
              onChange={(e) => this.handleAddAdvTyping(e, 'typingTitle')}
            />
          </div>
          <div className="addAdvModal">
            <label>价格:</label>
            <Input
              size="small"
              placeholder="请输入商品价格"
              value={typingPrice}
              onChange={(e) => this.handleAddAdvTyping(e, 'typingPrice')}
            />
          </div>
          <div className="addAdvModal">
            <label>链接:</label>
            <Input
              size="small"
              placeholder="请输入商品链接"
              value={typingUrl}
              onChange={(e) => this.handleAddAdvTyping(e, 'typingUrl')}
            />
          </div>
          <div className="addAdvModal">
            <label>图片:</label>
            <div className="advUpload">
              <div className="clearfix">
                <Upload
                  action="//up-z0.qbox.me/"
                  listType="picture-card"
                  data={{ token: this.state.qiuNiuToken }}
                  onPreview={this.handlePreview}
                  beforeUpload={this.beforeUpload}
                  onChange={(e) => {
                    this.handleChange(e)
                  }}
                >
                  {fileList.length >= 1 ? null : uploadButton}
                </Upload>
                <Modal
                  visible={previewVisible}
                  footer={null}
                  onCancel={this.handlePreviewCancel}
                >
                  <img
                    alt="example"
                    style={{ width: '100%' }}
                    src={previewImage}
                  />
                </Modal>
              </div>
            </div>
          </div>
          <span>建议上传同高宽的图片</span>
        </Modal>
      </div>
    )
  }
}

export default AdvManage



// WEBPACK FOOTER //
// ./src/containers/CheckOutAdvManage/components/AdvManage.js